
const ProjectCard = (props) => {
    return (
        <div className="transition text-white flex flex-col w-[350px] md:w-[800px] border-2 border-white rounded-lg justify-center hover:border-[#00fd9a] p-3 m-5">
            <p className="text-3xl md:text-4xl text-center mb-2">{props.project.title}</p>
            <p className="text-xl md:text-2xl text-center mb-6">({props.project.type})</p>

            <p className="text-lg md:text-xl mb-4">{props.project.description}</p>

            <p className="text-lg md:text-xl mb-4">Stack: {props.project.stack}</p>

            <a href={props.project.link} rel="noreferrer" target="_blank" className="transition text-lg md:text-xl text-center hover:text-[#00fd9a]">Link 🔗</a>

        </div>
    )
};

export default ProjectCard;